import React from "react";
import "../AchievementsComponent/AchievementsComponentCss/GavVikasSection.css";

// Image imports
import img1 from "../Images/imgSamvad.png";
import img2 from "../Images/imgSwachhta.png";
import img3 from "../Images/imgMahila.png";
import img4 from "../Images/imgGramSabha.png";

export default function GavVikasSection() {
  return (
    <section className="vikas-section">
      <h2 className="vikas-title">गाव विकासासाठी कार्यक्रम</h2>
      <p className="vikas-subtitle">
        स्वच्छ ग्राम अभियान – स्वच्छता, कचरा व्यवस्थापन आणि हरित उपक्रम.
      </p>

      <div className="vikas-grid">
        {/* Card 1 */}
        <div className="vikas-card">
          <img src={img1} alt="कार्यक्रम" className="vikas-img" />
          <div className="vikas-content">
            <h3>ग्रामसभेची चालू सत्र</h3>
            <p>
              ग्रामसभा ही गावकऱ्यांच्या सहभागातून निर्णय घेण्याचे व्यासपीठ आहे.
              चालू सत्रात गावाच्या विकासासाठी महत्त्वाचे निर्णय आणि योजना
              निश्चित केल्या जातात.
            </p>
            <ul>
              <li>गावातील विविध विकासकामांचे नियोजन</li>
              <li>नागरिकांच्या सूचना व तक्रारींची नोंद</li>
              <li>शासकीय योजनांची अंमलबजावणी </li>
              <li>प्रशासन आणि लोकसहभागावर भर</li>
            </ul>
          </div>
        </div>

        {/* Card 2 */}
        <div className="vikas-card">
          <img src={img2} alt="स्वच्छता" className="vikas-img" />
          <div className="vikas-content">
            <h3>स्वच्छता मोहीम</h3>
            <p>
              गाव स्वच्छ ठेवणे ही प्रत्येक नागरिकाची जबाबदारी आहे. स्वच्छता
              मोहिमेच्या माध्यमातून ग्रामपंचायत गावातील आरोग्य, पर्यावरण आणि
              सौंदर्य टिकवण्याचा प्रयत्न करते.
            </p>
            <ul>
              <li>घराघरातील कचऱ्याचे वर्गीकरण</li>
              <li>प्लास्टिक मुक्त गाव अभियान राबविणे</li>
              <li>सार्वजनिक ठिकाणांची साफसफाई</li>
              <li>स्वच्छतेबाबत जनजागृती करणे</li>
            </ul>
          </div>
        </div>

        {/* Card 3 */}
        <div className="vikas-card">
          <img src={img3} alt="महिला बचत गट" className="vikas-img" />
          <div className="vikas-content">
            <h3>महिला बचत गट उपक्रम</h3>
            <p>
              गावातील महिलांच्या आर्थिक सशक्तीकरण व स्वावलंबनासाठी
              राबविण्यात येणारा हा एक प्रभावी उपक्रम आहे. या माध्यमातून महिलांना
              रोजगार, बचत आणि आत्मनिर्भरतेची दिशा मिळते.
            </p>
            <ul>
              <li>स्वयंरोजगार आणि लघुउद्योगांना प्रोत्साहन.</li>
              <li>विविध प्रशिक्षणांद्वारे कौशल्यवृद्धी.</li>
              <li>नियमित बचतीद्वारे आर्थिक स्थैर्य वाढविणे.</li>
              <li>समाजातील महिला नेतृत्व विकास.</li>
            </ul>
          </div>
        </div>

        {/* Card 4 */}
        <div className="vikas-card">
          <img src={img4} alt="संवाद" className="vikas-img" />
          <div className="vikas-content">
            <h3>नागरिकांशी संवाद</h3>
            <p>
              ग्रामपंचायतीचा नागरिकांशी सतत संवाद हा पारदर्शक आणि प्रभावी
              प्रशासनाचा पाया आहे. गावातील प्रत्येक व्यक्तीचा आवाज ऐकला जावा आणि
              त्यावर कार्यवाही व्हावी, हे आमचे उद्दिष्ट आहे.
            </p>
            <ul>
              <li>बैठकीद्वारे थेट संवाद साधला जातो.</li>
              <li>निर्णय प्रक्रियेत नागरिकांचा सक्रिय सहभाग.</li>
              <li>तक्रारींसाठी ऑनलाइन सुविधा.</li>
              <li>प्रशासनातील पारदर्शकता वाढविणे.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
